import React from "react";
import { Modal, Button } from "antd";
import { useTranslation } from "react-i18next";
import { SONIC_PROSPECT_PRICING, formatProspectUsdTr } from "util/prospectBilling";
import styles from "./style.module.scss";

const SALES_CONTACT_MAIL =
  "mailto:sales@pivony.com?subject=Sonic%20Prospect%20outcome%20billing";

/** Sonic Prospect prices: one plan, pay per Qualified Prospect; Enterprise through sales. */
const SonicProspectUpgradeModal = ({ open, onClose }) => {
  const { t } = useTranslation();
  const { freeLifetimeQp, tier1Limit, tier1Price, tier2Price } = SONIC_PROSPECT_PRICING;

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      width={400}
      destroyOnClose
      title={t("sonic_prospect.outcome_modal_title")}
    >
      <div className={styles.outcomeBody}>
        <p className={styles.outcomeLead}>{t("sonic_prospect.outcome_modal_lead")}</p>
        <div className={styles.outcomePrice}>
          <p>{t("sonic_prospect.price_free_line", { count: freeLifetimeQp })}</p>
          <p>
            {t("sonic_prospect.price_paid_line", {
              price: formatProspectUsdTr(tier1Price),
              count: tier1Limit,
              after: formatProspectUsdTr(tier2Price),
            })}
          </p>
        </div>
        <p className={styles.outcomeEnterprise}>
          {t("sonic_prospect.outcome_modal_enterprise_line")}
        </p>
        <p className={styles.outcomeEnterprise}>{t("sonic_prospect.outcome_enterprise_line")}</p>
      </div>
      <div className={styles.outcomeActions}>
        <Button type="primary" block onClick={onClose}>
          {t("sonic_prospect.outcome_modal_close")}
        </Button>
        <Button type="link" block href={SALES_CONTACT_MAIL}>
          {t("sonic_prospect.plans_contact_sales")}
        </Button>
      </div>
    </Modal>
  );
};

export default SonicProspectUpgradeModal;
